import { canUseKeycloakLogin } from '../utils/keycloak';
import { keycloakConfigSelector } from '../helpers/selectors';
import { handleKeycloakLogin } from './keycloak';
import { popup_Generic_SetVisibility } from './popup';

// Lokalise does not know the key yet: the defaultMessage ships with the code and
// GenericPopup renders it until the key exists (it is on the Lokalise request list).
export const LOGIN_UNAVAILABLE_POPUP_DATA = {
  genericPopupKey: 'sso.login.unavailable',
  genericPopupDefault: 'Login is temporarily unavailable. Please try again later.'
};

/**
 * The one login entry point of the UI (header, brand login-message CTA, homepage
 * service tabs, the anonymous booking submit). Keycloak is the only way in, so
 * either the redirect starts, or the user is told logging in is not possible right
 * now - never a silent no-op and never a dead popup.
 *
 * Resolves with what handleKeycloakLogin resolves with: true only once the visitor
 * is actually on his way to Keycloak.
 */
export function startLoginOrExplain() {
  return (dispatch, getState) => {
    const keycloakConfig = keycloakConfigSelector(getState());
    const loginIsUsable = canUseKeycloakLogin(keycloakConfig);

    const explain = () =>
      dispatch(popup_Generic_SetVisibility(true, LOGIN_UNAVAILABLE_POPUP_DATA));

    console.log('[KC-DEBUG] actions/login.js/startLoginOrExplain: DECISION - KC login vs "login unavailable" popup', { hasKeycloakConfig: Boolean(keycloakConfig), goesToKeycloak: loginIsUsable }); // eslint-disable-line no-console
    if (!loginIsUsable) {
      explain();
      return Promise.resolve(false);
    }

    // handleKeycloakLogin resolves false when the login URL could not be built -
    // the visitor never left the page, so he gets the same explanation.
    return dispatch(handleKeycloakLogin(keycloakConfig)).then((redirected) => {
      if (!redirected) explain();
      return redirected;
    });
  };
}
